"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_TYPES = exports.SUBMIT_EXAM_ANSWER_BUFFER_MS = exports.EXAM_ALLOCATED_TIME_BUFFER_MS = exports.EXAM_NO_ANSWER_ID = void 0;
exports.EXAM_NO_ANSWER_ID = '-';
exports.EXAM_ALLOCATED_TIME_BUFFER_MS = 5000;
exports.SUBMIT_EXAM_ANSWER_BUFFER_MS = 10_000;
exports.MESSAGE_TYPES = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error',
};
//# sourceMappingURL=constants.js.map